import { render, staticRenderFns } from "./MailVerification.vue?vue&type=template&id=3aa94935&scoped=true&"
import script from "./MailVerification.vue?vue&type=script&lang=js&"
export * from "./MailVerification.vue?vue&type=script&lang=js&"
import style0 from "./MailVerification.vue?vue&type=style&index=0&id=3aa94935&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa94935",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VProgressCircular,VTextField})
